import {useRef, useEffect, useState} from "react";
import {useWindowSize} from "../../hooks";
import {useDarkMode} from "../../context";

export function VUMeterVisualizer({valueVU}) {
    const width = 50;
    const height = 250;

    const canvasRef = useRef(null);

    useEffect(() => {
        const ctx = canvasRef.current.getContext("2d");
        // ctx.fillStyle = "000";
        // ctx.strokeStyle = "black";

        let gradient;
        gradient = ctx.createLinearGradient(0, 0, 0, height);
        gradient.addColorStop(0, 'red');
        gradient.addColorStop(0.3, 'yellow');
        gradient.addColorStop(1, 'green');
        ctx.fillStyle = gradient;

        function updateVuMeter(volume) {
            // clear Canvas
            ctx.clearRect(0, 0, width, height);
            ctx.fillRect(0, height - volume * height, width, volume * height);
            ctx.strokeRect(0, 0, width, height);
        }

        updateVuMeter(valueVU)

    }, [valueVU]);

    return (<>
            <canvas ref={canvasRef} width={width} height={height}/>
        </>
    )
}

export function CustomVUMeterVisualizer({valueVU}) {
    const {darkMode} = useDarkMode()
    const {width} = useWindowSize()

    const widthMax = width < 576 ? 20 : 40
    const heightMax = width < 576 ? 150 : 180

    const [maskHeight, setMaskHeight] = useState(heightMax)
    const valueRef = useRef(0)

    useEffect(() => {
        valueRef.current = valueVU
    }, [valueVU])

    useEffect(() => {
        const int = setInterval(() => {
            if (valueRef.current > 0) {
                const newVal = Math.max(0, valueRef.current - 0.01)
                valueRef.current = newVal;
                setMaskHeight(heightMax - (newVal * heightMax))
            }
        }, 50)

        return () => clearInterval(int)
    }, [heightMax])


    const styleContainer = {
        position: 'relative',
        width: widthMax,
        height: heightMax,
        backgroundImage: 'linear-gradient(to top, var(--bs-success) 0%, var(--bs-success) 50%, var(--bs-warning) 85%, var(--bs-danger) 100%)',
        // border: '1px solid black',
        borderRadius: '5px',
    }

    const styleMask = {
        position: 'absolute',
        top: '0',
        width: widthMax,
        height: maskHeight,
        backgroundColor: darkMode ? '#212529' : '#f6f7f9',
        borderTopLeftRadius: '3px',
        borderTopRightRadius: '3px',

    }
    return <>
        <div style={styleContainer}>
            <div style={styleMask}></div>
        </div>
    </>
}